import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export const generatePDF = async (forEmail = false, state = {}) => {
  try {
    const isEMI = state.data?.proposalType?.type === 'EMI'
    /*const pdfsToGenerate = isEMI
      ? [['divToPrint', 'annexurePage'], ['invoiceOM']]
      : [['divToPrint', 'annexurePage']]*/

    const pdfsToGenerate = isEMI 
      ? [['divToPrint'], ['invoiceOM']]
      : [['divToPrint']]

    const pdfResults = []

    for (const pages of pdfsToGenerate) {
      const pdf = new jsPDF('p', 'mm', 'a4')

      for (let i = 0; i < pages.length; i++) {
        const content = document.getElementById(pages[i])
        if (!content) {
          console.warn('PDF generation skipped missing element:', pages[i])
          continue
        }

        // Hide specific UI elements for clean rendering
        const editButtons = content.querySelectorAll('.MuiIconButton-root')
        editButtons.forEach((button) => (button.style.display = 'none'))

        const actionColumns = content.querySelectorAll('.action-column')
        actionColumns.forEach((col) => (col.style.display = 'none'))

        // Hide pdf-only elements (like tax columns) when generating for email
        const pdfHideElements = content.querySelectorAll('.pdf-hide')
        if (forEmail) {
          pdfHideElements.forEach((el) => (el.style.display = 'none'))
        }

        const canvas = await html2canvas(content, {
          scale: forEmail ? 1.5 : 2,
          useCORS: true,
          logging: false,
          imageTimeout: 0,
          removeContainer: true,
          letterRendering: true,
        })

        const imgData = canvas.toDataURL('image/jpeg', forEmail ? 0.7 : 1.0)
        if (i > 0) pdf.addPage()

        const elementWidth = content.getBoundingClientRect().width
        const elementHeight = content.getBoundingClientRect().height
        const scaleFactor = pdf.internal.pageSize.getWidth() / elementWidth
        pdf.addImage(
          imgData,
          'JPEG',
          0,
          0,
          pdf.internal.pageSize.getWidth(),
          elementHeight * scaleFactor
        )

        // Revert UI changes after capturing
        editButtons.forEach((button) => (button.style.display = 'inline'))
        actionColumns.forEach((col) => (col.style.display = 'inline'))
        if (forEmail) {
          pdfHideElements.forEach((el) => (el.style.display = ''))
        }
      }

      pdfResults.push(pdf)
    }

    return pdfResults // Return array of PDFs
  } catch (error) {
    console.error('Error generating PDF:', error)
    throw error
  }
}

